import dayjs from 'dayjs';

export const dateTimeFormat = 'DD/MM/YYYY HH:mm:ss';
export const dateFormat = 'DD/MM/YYYY';
export const dateTimeFormatToFile = 'DD-MM-YYYY_HH-mm-ss';

export const getCurrentDateTimeToFile = () => dayjs().format(dateTimeFormatToFile);
export const getCurrentDateTime = () => dayjs().format(dateTimeFormat);
export const getCurrentDate = () => dayjs().format(dateFormat);

export const getGreeting = () => {
  const currentHour = dayjs().hour();
  let greeting;

  if (currentHour >= 5 && currentHour < 12) {
    greeting = 'Buenos días,';
  } else if (currentHour >= 12 && currentHour < 19) {
    greeting = 'Buenas tardes,';
  } else {
    greeting = 'Buenas noches,';
  }

  return greeting;
};

export const obtenerNombreCompletoDelMes = (abreviatura) => {
  const meses = {
    Ene: 'Enero',
    Feb: 'Febrero',
    Mar: 'Marzo',
    Abr: 'Abril',
    May: 'Mayo',
    Jun: 'Junio',
    Jul: 'Julio',
    Ago: 'Agosto',
    Sep: 'Septiembre',
    Oct: 'Octubre',
    Nov: 'Noviembre',
    Dic: 'Diciembre'
  };

  return meses[abreviatura] || 'Mes no válido';
};
